import { render } from "./Contacto.vue?vue&type=template&id=62ef37ed&scoped=true&ts=true"
import script from "./Contacto.vue?vue&type=script&lang=ts"
export * from "./Contacto.vue?vue&type=script&lang=ts"

import "./Contacto.vue?vue&type=style&index=0&id=62ef37ed&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Dell\\latam\\latamlogistichn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ef37ed"]])

export default __exports__